<template>
  <div>
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="250">

      <!--ACTIVATOR MENU-->
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex align-center">
              <v-btn text small class="indigo--text" v-bind="attrs" v-on="on">
                #{{ order.number }}
              </v-btn>
          <order-menu-icons v-if="showIcons" :order="order"/>
        </div>
      </template>

      <!--CONTENT MENU-->
      <v-card class="pb-1">
        <div class="pa-1">

          <v-dialog>
            <template v-slot:activator="{on}">
              <v-btn text small class="primary--text onPrimary" v-on="on">
                #{{ order.number }} - {{ order.contact.name }}
              </v-btn>
            </template>
            <v-toolbar dense></v-toolbar>
            <v-card>
              <v-card-text>
                <show-order
                    :identifier="order.identifier"
                ></show-order>
              </v-card-text>
            </v-card>

          </v-dialog>

          <print-ticket :order="order"></print-ticket>

          <v-btn class="ml-2 indigo--text" icon small @click="editOrder(order)">
            <v-icon>edit</v-icon>
          </v-btn>


          <v-btn class="ml-2 red--text" icon small @click="editState = true">
            <v-icon>do_not_disturb_off</v-icon>
          </v-btn>

          <confirm-dialog
              v-if="editState"
              v-model="editState"
              :title="'Cancelación de orden '+order.number"
              :description="'Seguro que desea cancelar la orden #'+order.number+'?'"
              @confirmed="onConfirmCancelation"
          ></confirm-dialog>


          <v-btn class="float-right" icon x-small @click="menu=false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <template v-if="order.promos.length > 0">
          <h6 class="subtitle-1 grey--text text--darken-4 py-0 px-2">
            Promos
          </h6>
          <v-list class="px-2 pt-0" dense>
            <template v-for="orderPromo in order.promos">
              <div :key="orderPromo.id">
                <customer-cart-detail-promo
                    :order-promo="orderPromo"
                    :show-remove-button="false"
                ></customer-cart-detail-promo>
                <v-divider class="my-2"></v-divider>
              </div>
            </template>
          </v-list>
        </template>

        <v-list dense v-for="category in getItemsCategories" :key="category.id" class="mb-0 pb-0">
          <span class="py-0 px-2 text-lg-h5 font-weight-bold" :style="{color: (category.fontColor ? category.fontColor : null )}">
             {{ category.printName ? category.printName : category.name }}
          </span>
          <v-list-item v-for="item in getItemsByCategory(category)"
                       :key="item.product.id">
            <v-list-item-avatar height="30" width="30" class="my-0"
                                :style="{backgroundColor: (category.backgroundColor ? category.backgroundColor : null )}">
              <v-img contain eager :src="item.product.image"/>
            </v-list-item-avatar>
            <v-list-item-title class="subtitle-1" :style="{color: (category.fontColor ? category.fontColor : null )}">
              {{ item.product.name }}
            </v-list-item-title>
            <v-list-item-avatar height="30" width="30" class="my-0">
              <v-chip small class="primary onPrimary--text font-weight-bold">x{{ item.quantity }}</v-chip>
            </v-list-item-avatar>
            <v-list-item-action class="my-0">
              <v-checkbox
                  hide-details

                  color="green"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list dense v-for="category in getItemsCategories" :key="category.name" class="mb-0 pb-0">
          <v-list-item>
            <v-list-item-title class="subtitle-1" :style="{color: (category.fontColor ? category.fontColor : null )}">
              {{ category.printName ? category.printName : category.name }}
            </v-list-item-title>
            <v-list-item-avatar height="30" width="30" class="my-0">
              <v-chip small class="primary onPrimary--text font-weight-bold">
                x{{ getItemsQuantityByCategory(category) }}
              </v-chip>
            </v-list-item-avatar>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list dense class="mb-0 pb-0">
          <v-list-item v-if="order.couponCode">
            <v-list-item-title class="subtitle-1">Cupón</v-list-item-title>
            <v-list-item-action ><span class="purple white--text px-1">{{ order.couponCode }}</span></v-list-item-action>
          </v-list-item>
          <v-divider v-if="order.couponCode"></v-divider>
          <v-list-item v-if="order.delivery.cost">
            <v-list-item-title class="subtitle-1">Costo de envío</v-list-item-title>
            <v-list-item-action class="subtitle-1">{{ currencyFormat(order.delivery.cost) }}</v-list-item-action>
          </v-list-item>
          <v-divider v-if="order.delivery.cost"></v-divider>
          <v-list-item>
            <v-list-item-title class="subtitle-1">Descuento</v-list-item-title>
            <v-list-item-action class="subtitle-1">-{{ currencyFormat(order.totalDiscount) }}</v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="subtitle-1">Total</v-list-item-title>
            <v-list-item-action class="subtitle-1"><b>{{ currencyFormat(order.totalAmount) }}</b></v-list-item-action>
          </v-list-item>
        </v-list>

      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {ClientError, ConfirmDialog} from "@dracul/common-frontend";
import CategoryMixin from "@/modules/delivery/mixins/CategoryMixin";
import PrintTicket from "@/modules/delivery/components-core/business/PrintTicket/PrintTicket.vue";
import OrderMenuIcons from "@/modules/delivery/components-core/business/OrderMenu/OrderMenuIcons.vue";
import ShowOrder from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrder.vue";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";
import CustomerCartDetailPromo
  from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetailPromo.vue";

export default {
  name: "OrderMenu",
  components: { CustomerCartDetailPromo, ShowOrder, OrderMenuIcons, PrintTicket, ConfirmDialog},
  mixins:[CategoryMixin, CurrencyMixin],
  props: {
    order: {type: Object},
    items: {type: Array},
    showIcons: {type: Boolean, default: true}
  },
  methods: {
    editOrder(order) {
      this.$router.push({name: 'BarOrderEditPage', params: {identifier: order.identifier}})
    },
    onConfirmCancelation(){
      OrderProvider.updateOrderState({
        id: this.order.id,
        state: 'CANCELED'
      })
          .then((r) => {
            this.onStateEdited(r.data.updateOrderState)
          })
          .catch(error => {
            console.error(error)
            let clientError = new ClientError(error)
            this.inputErrors = clientError.inputErrors
            this.errorMessage = clientError.i18nMessage
          })
          .finally(() => {
            this.loading = false
          })
    },
    onStateEdited(){
      this.editState = false
      this.$emit('stateEdited')
    }
  },
  data() {
    return {
      menu: false,
      editState: false,
    }
  }
}
</script>

